var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "onboarding-connect-pages" },
    [
      _c("OnboardingSteps", {
        attrs: {
          "current-step": "pages",
          "current-network": _vm.currentNetwork,
        },
        on: { "network-selected": _vm.handleNetworkSelected },
      }),
      _c("div", { staticClass: "onboarding-content" }, [
        _c("div", { staticClass: "onboarding-header" }, [
          _c("img", {
            staticClass: "onboarding-network-icon",
            attrs: { src: _vm.currentNetworkIcon, alt: _vm.currentNetworkName },
          }),
          _c("div", { staticClass: "onboarding-header-content" }, [
            _c("h1", { staticClass: "onboarding-header-title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$t("onboarding.connect_pages.connection_title", {
                      networkName: _vm.currentNetworkName,
                    })
                  ) +
                  "\n        "
              ),
            ]),
            _c("p", { staticClass: "onboarding-header-subtitle" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$t("onboarding.connect_pages.connection_subtitle", {
                      networkName: _vm.currentNetworkName,
                    })
                  ) +
                  "\n        "
              ),
            ]),
          ]),
        ]),
        _vm.networkFeatures.length > 0
          ? _c(
              "div",
              { staticClass: "onboarding-features-badges" },
              _vm._l(_vm.networkFeatures, function (feature) {
                return _c(
                  "span",
                  {
                    key: feature,
                    staticClass: "onboarding-feature-badge",
                    attrs: {
                      "data-tooltip": _vm.$t(
                        `onboarding.features.${feature}.description`
                      ),
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t(`onboarding.features.${feature}.title`)) +
                        "\n      "
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm.hasReachedPageQuota
          ? _c("div", { staticClass: "onboarding-quota-warning" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10 6V10M10 14H10.01M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                ]
              ),
              _c("div", [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("onboarding.connect_pages.quota_warning_title", {
                        current: _vm.totalSelectedPages,
                        max: _vm.userPlanPageQuota,
                      })
                    )
                  ),
                ]),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("onboarding.connect_pages.quota_warning_message")
                    ),
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "onboarding-pages-list" },
          [
            _c(
              "div",
              {
                staticClass: "onboarding-page-card onboarding-add-page-card",
                class: { disabled: _vm.hasReachedPageQuota },
                on: { click: _vm.connectNewPage },
              },
              [
                _c("div", { staticClass: "onboarding-add-icon" }, [
                  _vm._v("+"),
                ]),
                _c("div", { staticClass: "onboarding-add-text" }, [
                  !_vm.hasReachedPageQuota
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("onboarding.connect_pages.connect_new_page")
                          )
                        ),
                      ])
                    : _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("onboarding.connect_pages.quota_reached")
                          )
                        ),
                      ]),
                ]),
              ]
            ),
            _vm._l(_vm.connectedNetworkPages, function (page) {
              return _c(
                "div",
                {
                  key: page.id,
                  staticClass: "onboarding-page-card",
                  class: {
                    selected: _vm.isPageSelected(page.id),
                    "pre-existing": _vm.isPagePreExisting(page.id),
                    "non-deselectable":
                      _vm.isPagePreExisting(page.id) &&
                      _vm.isPageSelected(page.id),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.togglePageSelection(page.id)
                    },
                  },
                },
                [
                  _vm.isPagePreExisting(page.id)
                    ? _c("div", { staticClass: "pre-existing-badge" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getPreExistingBadgeText(page)) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  page.avatar && !_vm.imageLoadErrors[page.id]
                    ? _c("img", {
                        staticClass: "onboarding-page-avatar",
                        attrs: { src: page.avatar, alt: page.name },
                        on: {
                          error: function ($event) {
                            return _vm.handleImageError(page.id)
                          },
                        },
                      })
                    : _c(
                        "div",
                        {
                          staticClass:
                            "onboarding-page-avatar avatar-placeholder",
                          attrs: { role: "img", "aria-label": page.name },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(page.name.charAt(0).toUpperCase()) +
                              "\n        "
                          ),
                        ]
                      ),
                  _c("div", { staticClass: "onboarding-page-info" }, [
                    _c(
                      "div",
                      {
                        staticClass: "onboarding-page-name",
                        attrs: { title: page.name },
                      },
                      [_vm._v(_vm._s(page.name))]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "onboarding-page-username",
                        attrs: { title: page.username },
                      },
                      [_vm._v("@" + _vm._s(page.username))]
                    ),
                  ]),
                  _c("div", { staticClass: "onboarding-selection-indicator" }, [
                    _c("div", {
                      staticClass: "onboarding-selection-check",
                      class: { checked: _vm.isPageSelected(page.id) },
                    }),
                  ]),
                ]
              )
            }),
          ],
          2
        ),
        _c("div", { staticClass: "onboarding-footer-container" }, [
          _c("div", { staticClass: "onboarding-pages-counter" }, [
            _vm.selectedPageIds.length === 1
              ? _c("span", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.selectedPageIds.length) +
                      " \n            " +
                      _vm._s(
                        _vm.$t(
                          "onboarding.connect_pages.page_selected_singular"
                        )
                      ) +
                      "\n          "
                  ),
                ])
              : _c("span", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.selectedPageIds.length) +
                      "\n            " +
                      _vm._s(
                        _vm.$t("onboarding.connect_pages.page_selected_plural")
                      ) +
                      "\n          "
                  ),
                ]),
          ]),
          _c("div", { staticClass: "onboarding-footer" }, [
            _c(
              "button",
              {
                staticClass: "onboarding-btn-primary",
                attrs: { disabled: !_vm.canProceed },
                on: { click: _vm.goToNextStep },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("onboarding.connect_pages.next_step")) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _c("LoadingSpinner", { attrs: { show: _vm.isConnecting } }),
      _c("BlueskyModal", {
        ref: "blueskyModal",
        attrs: { active: _vm.blueskyAuth.active },
        on: {
          connect: _vm.handleBlueskyConnect,
          cancel: _vm.handleBlueskyCancel,
        },
      }),
      _c("GoogleRefreshModal", {
        attrs: { active: _vm.googleRefresh.active },
        on: {
          reconnect: _vm.handleGoogleReconnect,
          skip: _vm.handleGoogleRefreshSkip,
        },
      }),
      _c("modal-popup"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }